module.exports = __webpack_public_path__ + "static/learningmaterials-8fabde4c0be07771214ed78e79dbe63b.jpg";